module.exports = __webpack_public_path__ + "img/sh_login_logo.e8ae61aa.png";